export default __webpack_public_path__ + "static/assets/med_pill_square_in_L1_solid_l_01_f.18fb4a04.png";